module.exports = __webpack_public_path__ + "img/stock2.9568f3f5.png";